<template>
    <div>
        <card-header icon="fa-chart-line" title="Enrollment" />

        <card-body>
        </card-body>

        <card-footer>

        </card-footer>
    </div>
</template>

<script>
import CardHeader from "@/TIER/components/CardHeader";
import CardBody from "@/TIER/components/CardBody";
import CardFooter from "../../TIER/components/CardFooter";
import CardList from "../../TIER/components/CardList";
import SubheaderListItem from "../../TIER/components/SubheaderListItem";
import DataRow from "../../TIER/components/DataRow";
import SeparatorListItem from "../../TIER/components/SeparatorListItem";

import { client as http } from "@/http_client";

export default {
    components: {
        CardFooter, CardBody, CardHeader, CardList,
        SubheaderListItem, DataRow, SeparatorListItem
    },
    props: ['card', 'props', 'child'],
    data: function () {
        return {
            enrollments: {},
        };
    },
    methods: {
        loadReport(filterBy) {
            this.$emit('loading', true);
            http.get('reports/admin/enrollment', { params: { filterBy }})
                .then(response => {
                    this.enrollments = response.data;
                    this.$emit('loading', false);
                })
                .catch(error => {
                    this.$emit('loading', false);
                    this.$emit('error', error);
                });
        }
    },
    watch: {},
    mounted: function () {
        this.loadReport('day');
    }
}
</script>